import { PAINT_STYLES } from './utils/colorStyles'
import { IconPaintStyle } from './components/Icons'
import './PaintBrushQuickBar.css'

const QUICK_IDS = ['normal', 'oil', 'watercolor', 'impasto', 'acrylic']

export function PaintBrushQuickBar({ paintStyle, setPaintStyle, lang = 'he' }) {
  const items = PAINT_STYLES.filter((s) => QUICK_IDS.includes(s.id))
  const label =
    lang === 'en' ? 'Brush type' : 'סוג מברשת'

  return (
    <div className="paint-brush-quick-bar" role="group" aria-label={label}>
      <span className="paint-brush-quick-label">{label}</span>
      <div className="paint-brush-quick-btns">
        {items.map(({ id, label: heLabel }) => {
          const enLabels = {
            normal: 'Normal',
            oil: 'Oil brush',
            watercolor: 'Watercolor',
            impasto: 'Impasto',
            acrylic: 'Acrylic',
          }
          const title = lang === 'en' ? enLabels[id] || heLabel : heLabel
          return (
            <button
              key={id}
              type="button"
              className={`paint-brush-quick-btn ${paintStyle === id ? 'active' : ''} ${id === 'oil' ? 'paint-brush-quick-btn--oil' : ''}`}
              onClick={() => setPaintStyle(id)}
              title={title}
              aria-pressed={paintStyle === id}
            >
              <IconPaintStyle styleId={id} size={20} />
              <span className="paint-brush-quick-name">{title}</span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
